/* eslint-disable @typescript-eslint/no-unused-vars */
import { useEffect } from 'react';
import moment from 'moment';
import { checkValue } from 'src/components/common/helper';

export function useImageCacheReload() {
  useEffect(() => {
    if (!document) {
      return;
    }

    function onImgError(img, fn) {
      if (img?.complete) {
        if (!img?.naturalWidth || !img?.naturalHeight) {
          fn(img);
        }
      }
      // img.addEventListener('error', function() {
      //     fn(img)
      // })
    }

    const handleImageError = (svg) => {
      let currentSrc = svg?.getAttribute('src');
      currentSrc = currentSrc?.split('?')[0];
      if (currentSrc) {
        svg.setAttribute('src', `${currentSrc}?v=${moment().utc().format('YYYYMMDDHH')}`);
      }
    };

    const imageLoader = () => {
      const images = [...document?.querySelectorAll('img')]?.filter((e) => e?.src?.includes('.svg'));
      if (images) {
        images?.forEach((img) => {
          onImgError(img, handleImageError);
        });
      }
    };

    const timeout = setTimeout(() => {
      imageLoader();
    }, 5000); // 5 seconds timeout (adjust as needed)

    // Cleanup event listeners
    return () => {
      imageLoader();
      clearTimeout(timeout);
    };
  }, []); // Empty dependency array ensures that this effect runs only once on mount
}
